<template>
  <div class="col-sm-12 col-md-4 col-lg-4 blog-sidebar theiaStickySidebar">
    <div class="stickysidebar">
      <div class="card">
        <h4>Search</h4>
        <form>
          <div class="blog-search">
            <input
              type="text"
              class="form-control"
              id="search"
              placeholder="Enter Keyword"
            />
            <i class="feather-search"></i>
          </div>
        </form>
      </div>
      <div class="card">
        <h4>Latest Posts</h4>
        <ul class="latest-posts">
          <li>
            <div class="post-thumb">
              <router-link to="/blog/blog-details">
                <img
                  class="img-fluid"
                  src="@/assets/img/blog/latestpost-01.jpg"
                  alt="Post"
                />
              </router-link>
            </div>
            <div class="post-info">
              <p>Sarah</p>
              <h6>
                <router-link to="/blog/blog-details"
                  >These 15 Cabin Wedding Venues Have All the Rustic Vibes</router-link
                >
              </h6>
            </div>
          </li>
          <li>
            <div class="post-thumb">
              <router-link to="/blog/blog-details">
                <img
                  class="img-fluid"
                  src="@/assets/img/blog/latestpost-02.jpg"
                  alt="Post"
                />
              </router-link>
            </div>
            <div class="post-info">
              <p>Kim Forrest</p>
              <h6>
                <router-link to="/blog/blog-details"
                  >23 Super-Chic Blazer Dresses for Your Home Game</router-link
                >
              </h6>
            </div>
          </li>
          <li>
            <div class="post-thumb">
              <router-link to="/blog/blog-details">
                <img
                  class="img-fluid"
                  src="@/assets/img/blog/latestpost-03.jpg"
                  alt="Post"
                />
              </router-link>
            </div>
            <div class="post-info">
              <p>Jessica Estrada</p>
              <h6>
                <router-link to="/blog/blog-details"
                  >The Prettiest Floral Bats for a Rage Look</router-link
                >
              </h6>
            </div>
          </li>
          <li>
            <div class="post-thumb">
              <router-link to="/blog/blog-details">
                <img
                  class="img-fluid"
                  src="@/assets/img/blog/latestpost-04.jpg"
                  alt="Post"
                />
              </router-link>
            </div>
            <div class="post-info">
              <p>Naoimh</p>
              <h6>
                <router-link to="/blog/blog-details"
                  >31 Beautiful Courts Around the World</router-link
                >
              </h6>
            </div>
          </li>
        </ul>
      </div>
      <div class="card">
        <h4>Categories</h4>
        <ul class="categories">
          <li>
            <h6>
              <a href="javascript:void(0);"> Rules in Game <span>(100)</span></a>
            </h6>
          </li>
          <li>
            <h6>
              <a href="javascript:void(0);"> Badminton <span>(10)</span></a>
            </h6>
          </li>
          <li>
            <h6>
              <a href="javascript:void(0);"> Bats <span>(20)</span></a>
            </h6>
          </li>
          <li>
            <h6>
              <a href="javascript:void(0);"> New Game <span>(45)</span></a>
            </h6>
          </li>
          <li>
            <h6>
              <a href="javascript:void(0);"> Event <span>(25)</span></a>
            </h6>
          </li>
          <li>
            <h6>
              <a href="javascript:void(0);"> Rackets <span>(15)</span></a>
            </h6>
          </li>
          <li>
            <h6>
              <a href="javascript:void(0);"> New Courts <span>(121)</span></a>
            </h6>
          </li>
        </ul>
      </div>
      <div class="card tags-card">
        <h4>Tags</h4>
        <ul class="tags clearfix">
          <li><a href="javascript:void(0);" class="tag">Rackets</a></li>
          <li><a href="javascript:void(0);" class="tag">New Game</a></li>
          <li><a href="javascript:void(0);" class="tag">Dresses</a></li>
        </ul>
      </div>
    </div>
  </div>
</template>
